import {
  __,
  assoc,
  curry,
  fromPairs,
  ifElse,
  keys,
  map,
  pipe,
  reduce,
  when,
} from 'ramda'
import { isArray, isObject } from './type'

export const renameObjKeysBy = curry((func: any, obj: any): any =>
  when(
    (x: unknown): boolean => isObject(x) || isArray(x),
    ifElse(
      isArray,
      map(renameObjKeysBy(func)),
      pipe(
        keys,
        reduce(
          (acc, cur) => assoc(func(cur), renameObjKeysBy(func, obj[cur]), acc),
          {},
        ),
      ),
    ),
    obj,
  ),
)

export const toObject = curry((key, value) => fromPairs([[key, value]]))

export const flipObject = (obj: Record<string, string | number>) => {
  const result: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(obj)) {
    result[value] = key
  }
  return result
}

export const safeObject = (value: unknown) => {
  return value != null && typeof value === 'object' && !Array.isArray(value)
    ? value
    : {}
}
